import { Modal } from '@mlc/web-ui-toolkit';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
	withAuth0,
	WithAuth0Props,
	withAuthenticationRequired,
} from '@auth0/auth0-react';
import { isEmpty } from 'lodash';
import { getCookies, getLicenseeTypes } from './components/common/utils';
import { NavigationTree } from './logic/domains/navigationTree.domain';
import { getNavigationTree } from './logic/functions/getNavigationTree.function';
import Routing from './routing/Routing';
import { injectAllConfiguredRoutes } from './routing/util/NavTreePathInjector.util';
import {
	adviserSetDetailsAction,
	getEmulatedAdviserDetailsAction,
} from './store/actions/adviser.actions';

import { AppVersion } from './AppVersion';
import { SessionTracker } from './SessionTracker';
import auth from './logic/functions/core/auth-client';
import LoadingIndicator from './components/common/LoadingIndicator';

type DispatchProps = {
	dispatch: any;
};

type ReduxStateProps = {
	errorWhileAuth: boolean;
	isAuthorised: boolean;
	mlcUserGroups: any;
};

interface State {
	navigationTree?: NavigationTree;
}

const initialState: State = {};

type Props = DispatchProps & ReduxStateProps & WithAuth0Props;

class App extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = initialState;
		if (!Object.isFrozen(auth)) {
			auth.getAccessTokenSilently = this.props.auth0.getAccessTokenSilently;
			Object.freeze(auth);
		}
	}

	async componentDidMount() {
		const { dispatch } = this.props;

		const officeUserEmulationId: string = this.getUserUUID();

		if (!officeUserEmulationId) {
			dispatch(adviserSetDetailsAction(this.getUserId()));
		} else {
			dispatch(getEmulatedAdviserDetailsAction(officeUserEmulationId));
		}
	}

	async UNSAFE_componentWillReceiveProps(nextProps: any) {
		if (!isEmpty(nextProps.mlcUserGroups)) {
			this.setState({
				navigationTree: injectAllConfiguredRoutes(
					await getNavigationTree(getLicenseeTypes(nextProps.mlcUserGroups))
				),
			});
		}
	}

	getUserId = () => {
		return getCookies().userId;
	};

	getUserUUID = () => {
		return getCookies().userUUID;
	};

	public render() {
		Modal.setAppElement('body');

		if (this.props.errorWhileAuth) {
			window.location.href = '/common/generic-error';
			return null;
		}

		if (!this.props.isAuthorised) {
			window.location.href = '/common/unauthorised-error';
			return null;
		}

		return this.state.navigationTree ? (
			<Fragment>
				<Routing navigationTree={this.state.navigationTree} />
				<AppVersion />
				<SessionTracker />
			</Fragment>
		) : (
			<LoadingIndicator />
		);
	}
}

const mapReduxStateToComponentProps = (state: any): ReduxStateProps => {
	return {
		errorWhileAuth: state.adviser.error,
		isAuthorised: state.adviser.isAuthorised,
		mlcUserGroups: state.adviser.adviserDetails.roles,
	};
};

export default connect(mapReduxStateToComponentProps)(
	withAuth0(withAuthenticationRequired(App))
);
